/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import baustein from "baustein";
import analytics from "analytics/analytics";
import { addVisibilityWatcher } from "modules/run-loop";
import googleCsa from "../embedded/google-adsense";
import browser from "../utils/browser";

const channelIdMap = {
    "oos-pdp": { mobile: "1598572231", desktop: "8791081831" },
    "instock-pdp": { mobile: "8526409836", desktop: "7049676638" },
    "clp-top": { mobile: "8286600639", desktop: "6809867433" },
    "clp-end": { mobile: "8718859835", desktop: "7242126631" },
    "clp-top-both": { mobile: "8286600639+6754983760", desktop: "6809867433+6754983760" },
    "clp-end-both": { mobile: "8718859835+6754983760", desktop: "7242126631+6754983760" }
};

export default baustein.register("adsense-custom-search-ads", {
    init() {
        googleCsa();
    },

    onInsert() {
        // modules with 'position' set are triggered explicitly
        if (!this.options.dataPosition) {
            this._removeVisiblityWatcher = addVisibilityWatcher(this.el, visible => {
                if (visible) {
                    this.createCsaUnit();
                    this._removeVisiblityWatcher();
                }
            });
        }
    },

    createCsaUnit() {
        const csaContainer = this.el.querySelector(".adsense-container");
        const { keyword, pagetype } = this.options;

        const channelId = getChannelId(pagetype);

        const pageOptions = {
            pubId: "pub-6862407432380262",
            query: keyword,
            adPage: 1,
            location: false,
            siteLinks: showSitelinks(pagetype),
            channel: channelId
        };

        const adblock1 = {
            container: csaContainer.id,
            width: "100%",
            maxTop: 2,
            fontFamily: "helvetica neue",
            colorTitleLink: "021135",
            colorDomainLink: "6D7288",
            colorText: "021135",
            adLoadedCallback: function(containerName, adsLoaded) {
                if (adsLoaded) {
                    try {
                        onAdLoaded(csaContainer);
                    } catch (err) {
                        // do nothing
                    }
                }
            }
        };

        googleCsa("ads", pageOptions, adblock1);
        analytics.event("adsense", "impression", null, true);
    }
});

function getChannelId(pagetype) {
    let deviceMap = channelIdMap[pagetype];
    switch (browser.getViewport()) {
        case browser.VIEWPORTS.MOBILE:
            return deviceMap["mobile"];
        default:
            return deviceMap["desktop"];
    }
}

function showSitelinks(pagetype) {
    if (pagetype && pagetype === "instock-pdp") {
        return true;
    }
    return false;
}

function onAdLoaded(csaContainer) {
    let csaIframe = csaContainer.firstElementChild;
    let mouseClick = false;
    let touchClick = false;

    function mouseEnter() {
        mouseClick = true;
    }

    function mouseLeave() {
        mouseClick = false;
    }

    function touchStart() {
        touchClick = true;
    }

    function touchMove() {
        touchClick = false;
    }

    function estimatedClick() {
        if (mouseClick || touchClick) {
            // remove all listeners once guesstimate click event occurs
            csaIframe.removeEventListener("mouseenter", mouseEnter);
            csaIframe.removeEventListener("mouseleave", mouseLeave);
            csaIframe.removeEventListener("touchstart", touchStart);
            csaIframe.removeEventListener("touchmove", touchMove);

            window.removeEventListener("blur", estimatedClick);

            analytics.event("adsense", "click");
        }
    }

    // add guesstimate click listeners
    csaIframe.addEventListener("mouseenter", mouseEnter);
    csaIframe.addEventListener("mouseleave", mouseLeave);
    csaIframe.addEventListener("touchstart", touchStart);
    csaIframe.addEventListener("touchmove", touchMove);

    window.addEventListener("blur", estimatedClick);
}

